import { useQuery } from "@tanstack/react-query"

import { Resource, Scope } from "@/constants/permission"
import { ORDER_DISPATCHER_TIME_COUNT_QUERY_KEY, ORDER_DISPATCHER_TIME_QUERY_KEY } from "@/constants/query"
import { getDispatcherTimeCoordinate, getDispatcherTimeCoordinateById, getDispatcherTimeCoordinateCount } from "@/http/dispatcherTimeCoordinate"

import { usePermission } from "@/hook/usePermission"

import { IRequestParams } from "@/types/api"


export const useDispatcherTimeCoordinateQuery = (params?: IRequestParams) => {
  return useQuery({
    queryFn: () => getDispatcherTimeCoordinate(params || {}),
    queryKey: [ORDER_DISPATCHER_TIME_QUERY_KEY, params],
    retry: false,
    refetchInterval: 60000
  })
}

export const useDispatcherTimeCoordinateCountQuery = () => {
  const { hasPermission } = usePermission()

  return useQuery({
    queryFn: () => getDispatcherTimeCoordinateCount(),
    queryKey: [ORDER_DISPATCHER_TIME_COUNT_QUERY_KEY],
    retry: false,
    refetchInterval: 60000,
    enabled: hasPermission(Resource.DispatcherTimeCoordinate, Scope.Read)
  })
}

export const useDispatcherTimeCoordinateByIdQuery = (id: number, skip: boolean = false) => {
  return useQuery({
    queryFn: () => getDispatcherTimeCoordinateById(id),
    queryKey: [ORDER_DISPATCHER_TIME_QUERY_KEY, id],
    enabled: !skip && id !== 0
  })
}